import React from 'react';
import { useSelector } from 'react-redux';

import { Button } from '../../../builder-io/storyblocks-design-system/components/atoms/Button/Button';
import { selectVoiceoverFlag } from '../selectors/searchSelectors';

export default function VoiceoverBannerCTA() {
  const showBanner = useSelector(selectVoiceoverFlag);

  if (!showBanner) {
    return null;
  }

  return (
    <div className="w-full flex justify-center mb-5 -mt-3">
      <div
        className="rounded-lg w-full p-0.5 max-w-4xl"
        style={{
          background: 'linear-gradient(to right, #9952E0, #FAE3D7, #FF66E6)',
        }}
      >
        <div
          className="flex items-center justify-between px-6 py-4 bg-white"
          style={{ borderRadius: '7px' }}
        >
          <span
            className="px-1.5 py-0.5 text-white font-semibold text-sm"
            style={{
              background: 'linear-gradient(to right, #9952E0, #FF66E6)',
              borderRadius: '4px',
            }}
          >
            New
          </span>

          <div className="flex items-center gap-2">
            <img
              src={`${__ASSETS_COMMON_IMAGES_URL__}/icons/ai-voiceover-diamond.svg`}
              alt="voiceover icon"
              className="w-4 h-4"
            />
            <h3 className="text-base font-semibold m-0">AI Voiceover</h3>
          </div>

          <p className="text-sm m-0 hidden lg:block">
            Add professional voiceovers to any video in seconds
          </p>

          <Button href="/voiceover">Try it now</Button>
        </div>
      </div>
    </div>
  );
}
